module.exports = __webpack_public_path__ + "img/done.af98546f.svg";